<template>
  <div class="dropdown-parent-container">
    <button
      type="button"
      :title="`${isOpen ? 'Close' : 'Open'} Price Percent Menu`"
      class="dropdown-menu-toggle-arrow-icon-button price-percent-menu-toggle-button"
      :class="{ 'dropdown-menu-toggle-arrow-icon-button-open': isOpen }"
      ref="pricePercentageDropdownMenuButton"
      @click="toggleDropdown()"
    >
      <i class="fas fa-fw fa-percent"></i>
      &nbsp;
      <i class="fas fa-angle-down"></i>
    </button>
    <DropdownMenu
      :nodes-excluded-from-closing-on-outside-click="pricePercentageDropdownMenuButton ? [pricePercentageDropdownMenuButton] : []"
      :is-aligned-to-right-of-button="true"
      :style="{ right: '0px' }"
      v-model:is-open="isOpen"
      v-model:max-body-height="dropdownHeight"
      :dropdown-menu-toggle-button-node="pricePercentageDropdownMenuButton"
    >
      <template v-slot:body>
        <ul>
          <li v-for="value in adjustmentValues">
            <button
              type="button"
              @click="[closeDropdown(), onPercentValueSelect(value)]"
            >{{ value }}% Up</button>
          </li>
          <li class="dropdown-divider"></li>
          <li v-for="value in reversedAdjustmentValues">
            <button
              type="button"
              @click="[closeDropdown(), onPercentValueSelect(-value)]"
            >{{ value }}% Down</button>
          </li>
        </ul>
      </template>
    </DropdownMenu>
  </div>
</template>

<script lang="ts" setup>
  import { ref, watch } from 'vue';
  import DropdownMenu from '@/components/dropdowns/DropdownMenu.vue';

  const emit = defineEmits<{
    (e: 'change:percentageValue', percentageValue: number): void;
  }>();

  const adjustmentValues = [20, 10, 5, 2];
  const reversedAdjustmentValues = adjustmentValues.slice().reverse();
  const pricePercentageDropdownMenuButton = ref<HTMLButtonElement>();
  const isOpen = ref<boolean>(false);
  const dropdownHeight = ref<number>(0);

  function toggleDropdown() {
    isOpen.value = !isOpen.value;
  }

  function closeDropdown() {
    isOpen.value = false;
  }

  function onPercentValueSelect(percent: number) {
    emit('change:percentageValue', percent);
  }

  watch(isOpen, () => {
    if (!isOpen.value) {
      pricePercentageDropdownMenuButton.value?.blur();
    }
  });
</script>

<style scoped>
  .dropdown-parent-container {
    position: relative;
  }

  ul {
    max-height: v-bind('`${dropdownHeight}px`');
  }

  ul li button {
    padding: 2px 10px;
  }

  .price-percent-menu-toggle-button {
    display: inline-block;
    vertical-align: bottom;
    background-color: transparent;
    border: none;
    font-size: 6px;
    color: #8d99a5;
    border-radius: 5px;
    padding: 0px;
    width: 35px;
    height: 35px;
    transition: all 0.35s ease;
  }

  .price-percent-menu-toggle-button i {
    font-size: 12px;
  }

  .price-percent-menu-toggle-button:hover,
  .price-percent-menu-toggle-button:active,
  .price-percent-menu-toggle-button:focus,
  .price-percent-menu-toggle-button.dropdown-menu-toggle-arrow-icon-button-open {
    background-color: #f2f5f7;
  }
</style>
